import { warn } from 'helper/debug';
import { compileDynamicRoute } from 'helper/string';
import { CustomOverlayTargets, CustomOverlayType } from 'store/events';
import { TargetType } from 'types/NotificationTargets';
import { routes } from '..';

export const TargetTypes = {
	Route: 'ROUTE',
	Close: 'CLOSE',
	Href: 'HREF',
	ExternalHref: 'EXTERNAL_HREF',
	ExternalHrefWithReload: 'EXTERNAL_HREF_RELOAD',
	LoginButton: 'LOGIN_BUTTON',
	Action: 'ACTION',
	Reload: 'RELOAD',
	RouteAction: 'ROUTE_ACTION',
};

export const TargetActions = {
	OverwriteProgram: 'OVERWRITE_PROGRAM',
	StartProgram: 'START_PROGRAM',
	ReplaceProgram: 'REPLACE_PROGRAM',
	SaveParticipateCompetition: 'SAVE_PARTICIPATE_COMPETITION',
	SaveDsgvo: 'SAVE_DSGVO',
	SaveCustomOverlayShown: 'SAVE_CUSTOM_OVERLAY_SHOWN',
};

export const getTargetFromFactory = (
	factory: { [key: string]: any /* TargeType */ },
	key: string
): any /* TargetType */ => {
	if (!factory || !key) {
		warn('Invalid factory or key for target mapping (%s@%s)', key, JSON.stringify(factory));
	}

	const target: TargetType = factory[`${key}`];

	if (!target) {
		warn('Key %s not found in Targets: %s', key, Object.keys(factory).join(', '));
	}

	return target || '';
};

export const getCustomOverlayTargets = (overlay: CustomOverlayType): TargetType | undefined => {
	const targetRouteMap = {
		[CustomOverlayTargets.ProgramFeed]: routes.today.indexRoute.href,
		[CustomOverlayTargets.Dashboard]: routes.dashboard.indexRoute.href,
		[CustomOverlayTargets.Profile]: routes.profile.indexRoute.href,
		[CustomOverlayTargets.Favorites]: routes.favorites.indexRoute.href,
		[CustomOverlayTargets.MySuccess]: routes.mySuccess.indexRoute.href,
		[CustomOverlayTargets.ProgramsRecommended]: routes.program.recommended.href,
		[CustomOverlayTargets.ProgramsFurther]: routes.program.further.href,
		[CustomOverlayTargets.ProgramPreview]: routes.program.preview.href,
	};

	const secondary = overlay.closingLabel
		? {
				type: TargetTypes.Close,
				label: overlay.closingLabel,
		  }
		: void 0;

	switch (overlay.target) {
		case CustomOverlayTargets.ProgramFeed:
		case CustomOverlayTargets.Dashboard:
		case CustomOverlayTargets.Profile:
		case CustomOverlayTargets.Favorites:
		case CustomOverlayTargets.MySuccess:
		case CustomOverlayTargets.ProgramsRecommended:
		case CustomOverlayTargets.ProgramsFurther:
			return {
				primary: {
					type: TargetTypes.Route,
					value: {
						href: targetRouteMap[overlay.target],
					},
					label: overlay.targetLabel,
				},
				secondary,
			};
		case CustomOverlayTargets.ProgramPreview:
			return {
				primary: {
					type: TargetTypes.Route,
					value: {
						href: compileDynamicRoute(targetRouteMap[overlay.target], {
							id: overlay.programPreview!,
						}),
					},
					label: overlay.targetLabel,
				},
				secondary,
			};
		case CustomOverlayTargets.External:
			return {
				primary: {
					type: TargetTypes.ExternalHref,
					value: {
						href: overlay.external ? overlay.external : '',
					},
					label: overlay.targetLabel,
				},
				secondary,
			};
		case CustomOverlayTargets.NoTarget:
			return {
				secondary,
			};

		default:
			return void 0;
	}
};
